<template>
  <div class="project-communication">
    <b-row>
      <b-col
        v-if="showToGuest('employerCommunication', guestVisibleSections)"
        lg="5"
        md="5"
        sm="12"
      >
        <legend>
          <strong>{{ $t('communication_with_employer') }}</strong>
        </legend>

        <div class="label">{{ $t('askEmployerCategoryState') }}</div>
        <div>
          <multiselect
            :placeholder="$t('askEmployerCategoryState')"
            v-model="project.askEmployerCategoryState"
            id="askEmployerCategoryState"
            :options="getEnumValues('AskEmployerCategoryState')"
            :allow-empty="true"
            :show-labels="false"
            :disabled="!canWriteField('askEmployerCategoryState', guestWritableFields)"
            deselectLabel
          >
            <template slot="singleLabel" slot-scope="{ option }">
              <b-badge>
                {{ $t(option) }}
              </b-badge>
            </template>
            <template slot="option" slot-scope="{ option }">
              <b-badge>
                {{ $t(option) }}
              </b-badge>
            </template>
          </multiselect>
        </div>

        <div class="label">{{ $t('askEmployerNote') }}</div>
        <div class="dense-editor">
          <ckeditor
            :editor="editor"
            v-model="project.askEmployerNote"
            :config="editorConfig"
            :disabled="!canWriteField('askEmployerNote', guestWritableFields)"
          ></ckeditor>
        </div>

        <div class="label">{{ $t('answerFromEmployerNote') }}</div>
        <div class="dense-editor">
          <ckeditor
            :editor="editor"
            v-model="project.answerFromEmployerNote"
            :config="editorConfig"
            :disabled="!canWriteField('answerFromEmployerNote', guestWritableFields)"
          ></ckeditor>
        </div>
      </b-col>

      <b-col v-if="showToGuest('tasks', guestVisibleSections)" lg="7" md="7" sm="12">
        <legend>
          <strong>{{ $t('tasks') }}</strong>
        </legend>

        <TaskTable :project="project" />
      </b-col>
    </b-row>

    <b-row v-if="showToGuest('posts', guestVisibleSections)" class="mt-4">
      <b-col cols="12">
        <ProjectCardPosts :project="project" />
      </b-col>
    </b-row>

    <b-row v-if="showToGuest('email', guestVisibleSections)" class="mt-4">
      <b-col cols="12">
        <legend>
          <strong>{{ $t('email') }}</strong>
        </legend>
        <ProjectMessages :project="project" :selectedAppointment="selectedAppointment" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import InlineEditor from '@ckeditor/ckeditor5-build-inline';
import { mapGetters } from 'vuex';
import TaskTable from '@/components/TaskTable';
import ProjectMessages from '@/views/Projects/ProjectMessages';
import ProjectCardPosts from '@/views/Projects/ProjectCardPosts';
import { canWriteField, showToGuest } from '@/helpers/userCapabilities';

export default {
  components: {
    Multiselect,
    ckeditor: CKEditor.component,
    TaskTable,
    ProjectMessages,
    ProjectCardPosts,
  },
  props: {
    project: { type: Object },
    selectedAppointment: { type: Object, default: null },
  },
  data() {
    return {
      editor: InlineEditor,
      editorConfig: {},
      // Guest permissions
      guestWritableFields: {
        askEmployerCategoryState: true,
        askEmployerNote: true,
        answerFromEmployerNote: true,
      },
      guestVisibleSections: {
        employerCommunication: true,
        tasks: true,
        email: false,
        posts: false,
      },
    };
  },
  computed: {
    ...mapGetters(['getEnumValues']),
  },
  methods: {
    showToGuest,
    canWriteField,
  },
};
</script>

<style scoped lang="scss">
.dense-editor {
  height: auto;
  max-height: 300px;
  overflow-y: auto;
}

.ck-editor__editable_inline {
  min-height: 110px;
  height: auto;
  max-height: 300px;
  overflow-y: auto;
}
</style>
